export const m = {
    // sideBar
    WhatIsFaxchain: 'What is FaxChain',
    Introduction: 'Introduction',
    OnThisPage: 'On this page',
    ConsensusProtocol: 'Consensus Protocol',
    KeyFeatures: 'Key Features',
    Speed: 'Speed',
    Scalability: 'Scalability',
    Security: 'Security',
    Flexibility: 'Flexibility',
    Sustainability: 'Sustainability',
    SmartContractSupport: 'Smart Contract Support',
    PrivateAndPublicBlockchains: 'Private and Public Blockchains',
    DesignedForFinance: 'Designed for Finance',
    Learn: 'Learn',
    GettingStarted: 'Getting Started',
    TokenAndFees: 'Token and Fees',
    Wallet: 'Wallet',
    Transactions: 'Transactions',
    Platform: 'Platform',
    FaxchainPlatformOverview: 'Faxchain Platform Overview',
    Subnets: 'Subnets',
    Compliance: 'Compliance',
    FaxchainBlockchainConsensus: 'Faxchain Blockchain Consensus',
    Video: 'Video',
    Intuition: 'Intuition',
    Snowball: 'Snowball',
    Staking: 'Staking',
    FaxchainTransactionFee: 'Faxchain Transaction Fee',
    FaxchainBridge: 'Faxchain Bridge(AB)',
    ImportantInformation: 'Important Information',
    UserNotes: 'User Notes',
    HowToUseLedger: 'How to Use Ledger Nano S/X',
    BlockchainBasic: 'Blockchain Basic',
    FAQ: 'FAQ',
    Forum: 'Forum',
    Ecosystem: 'Ecosystem',
    Build: 'Build',
    ReleaseNotes: 'Release Notes',
    FaxchainGo: 'FaxchainGo',
    FaxchainNotify: 'Faxchain Notify',
    Tutorials: 'Tutorials',
    Overview: 'Overview',
    Subnets: 'Subnets',
    CreateLocalTestNetwork: 'Create a Local Test Network',
    FujiWorkflow: 'Fuji Workflow',
    FundLocalTestNetwork: 'Fund a Local Test Network',
    NodesAndStaking: 'Nodes and Staking',
    SmartContract: 'Smart Contract',
    SmartDigitalAssets: 'Smart Digital Assets',
    TutorialsContest: 'Tutorials Contest',
    IssuingAPICalls: 'Issuing API Calls',
    Tools: 'Tools',
    PublicAPI: 'Public API',
    References: 'References',
    CryptographicPrimitives: 'Cryptographic Primitives',
    NetworkProtocol: 'Network Protocol',
    SerializationPrimitives: 'Serialization Primitives',
    PlatformTransactionFormat: 'Platform Transaction Format',
    Whitepapers: 'Whitepapers',
    Audits: 'Audits',

}